export default Function.prototype;
